import React from 'react';

import Close from '@material-ui/icons/Clear';
import Delete from '@material-ui/icons/Delete';

export class NumPad extends React.Component {
    state = {
        displayValue: this.props.value ? this.props.value.toString() : '',
        waitingForOperand: false,
    };

    clearAll() {
        this.setState({
            displayValue: '',
            waitingForOperand: false,
        });
    }

    clearDisplay() {
        this.setState({
            displayValue: '0',
        });
    }

    clearLastChar() {
        const { displayValue } = this.state;
        this.setState({
            displayValue:
                displayValue && displayValue.length > 1
                    ? displayValue.substring(0, displayValue.length - 1)
                    : '',
        });
    }

    toggleSign() {
        const { displayValue } = this.state;
        let newValue = '-';
        if (displayValue && displayValue !== '-') {
            newValue = parseFloat(displayValue) * -1;
        } else if (displayValue === '-') {
            newValue = '';
        }

        this.setState({
            displayValue: String(newValue),
        });
    }

    close() {
        const { displayValue } = this.state;
        this.props.onClose(displayValue);
    }

    inputDot() {
        const { displayValue } = this.state;
        if (!/\./.test(displayValue)) {
            this.setState({
                displayValue: displayValue + '.',
                waitingForOperand: false,
            });
        }
    }

    inputDigit(digit) {
        const { displayValue, waitingForOperand } = this.state;
        if (waitingForOperand) {
            this.setState({
                displayValue: String(digit),
                waitingForOperand: false,
            });
        } else {
            this.setState({
                displayValue: displayValue === '0' ? String(digit) : displayValue + digit,
            });
        }
    }

    handleKeyDown = (event) => {
        let { key } = event;
        if (key === 'Enter') {
            event.preventDefault();
            this.close();
        } else if (/\d/.test(key)) {
            event.preventDefault();
            this.inputDigit(parseInt(key, 10));
        } else if (key === '.') {
            event.preventDefault();
            this.inputDot();
        } else if (key === 'Backspace') {
            event.preventDefault();
            this.clearLastChar();
        } else if (key === 'Clear') {
            event.preventDefault();
            this.clearAll();
        }
    };

    UNSAFE_componentWillMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    render() {
        const { displayValue } = this.state;
        return (
            <div className="numpad calculator">
                <div className="flex_full_column">
                    <div className="flex_full_row align_center bg_cool_grey">
                        <div className="calculator-display">{displayValue}</div>
                        <Close
                            className={'float_close c_bluish hand margin_right_12'}
                            onClick={this.close.bind(this)}
                        />
                        <Delete
                            className={'float_delete c_lipstick hand margin_right_12'}
                            onClick={this.clearAll.bind(this)}
                        />
                    </div>
                    <div className="calculator-keypad">
                        <div className="input-keys">
                            <div className="digit-keys">
                                <div
                                    className="button calculator-key key-sign"
                                    onClick={() => this.toggleSign()}
                                >
                                    ±
                                </div>
                                <div
                                    className="button calculator-key key-0"
                                    onClick={() => this.inputDigit(0)}
                                >
                                    0
                                </div>
                                <div
                                    className="button calculator-key key-dot"
                                    onClick={() => this.inputDot()}
                                >
                                    ●
                                </div>
                                <div
                                    className="button calculator-key key-1"
                                    onClick={() => this.inputDigit(1)}
                                >
                                    1
                                </div>
                                <div
                                    className="button calculator-key key-2"
                                    onClick={() => this.inputDigit(2)}
                                >
                                    2
                                </div>
                                <div
                                    className="button calculator-key key-3"
                                    onClick={() => this.inputDigit(3)}
                                >
                                    3
                                </div>
                                <div
                                    className="button calculator-key key-4"
                                    onClick={() => this.inputDigit(4)}
                                >
                                    4
                                </div>
                                <div
                                    className="button calculator-key key-5"
                                    onClick={() => this.inputDigit(5)}
                                >
                                    5
                                </div>
                                <div
                                    className="button calculator-key key-6"
                                    onClick={() => this.inputDigit(6)}
                                >
                                    6
                                </div>
                                <div
                                    className="button calculator-key key-7"
                                    onClick={() => this.inputDigit(7)}
                                >
                                    7
                                </div>
                                <div
                                    className="button calculator-key key-8"
                                    onClick={() => this.inputDigit(8)}
                                >
                                    8
                                </div>
                                <div
                                    className="button calculator-key key-9"
                                    onClick={() => this.inputDigit(9)}
                                >
                                    9
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/NumPad.js